module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-8-a71bb0593bee543aba6e155e26a2cb65.jpg";